// extracted by mini-css-extract-plugin
var _1 = "floating-contact-button-module--floatingContactButton--a9bb5";
var _2 = "floating-contact-button-module--floatingContactButtonIcon--7564b";
var _3 = "floating-contact-button-module--floatingContactButtonLabel--d18f1";
var _4 = "floating-contact-button-module--open--ab0d1";
var _5 = "floating-contact-button-module--srOnly--5736e";
export { _1 as "floatingContactButton", _2 as "floatingContactButtonIcon", _3 as "floatingContactButtonLabel", _4 as "open", _5 as "srOnly" }
